import { render } from "./AllQcmPackages.vue?vue&type=template&id=f3c4600a"
import script from "./AllQcmPackages.vue?vue&type=script&lang=js"
export * from "./AllQcmPackages.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__